/* eslint-disable jsx-a11y/anchor-is-valid */
import { Table } from 'antd';
import { useRef } from 'react';
import { t_cpap_instructions } from 'types';
import ModalPatient from './ModalPatient';

type Props = {
  data: t_cpap_instructions[];
};

const TableConsultation = ({ data }: Props) => {
  const ref: any = useRef(null);
  return (
    <div>
      <Table
        columns={[
          {
            title: '医療機関名',
            dataIndex: 'facility_name',
            key: 'facility_name',
            width: '35%',
            align: 'center',
            render(text: string) {
              return {
                props: {
                  style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: '患者名',
            dataIndex: 'patient_name',
            key: 'patient_name',
            width: '25%',
            align: 'center',
            render(text: string) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: '未受診期間',
            dataIndex: 'period_of_no_visit_medical',
            key: 'period_of_no_visit_medical',
            width: '25%',
            align: 'center',
            render(text: string) {
              return {
                props: {
                  style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{text ?? 0}ヶ月</div>,
              };
            },
          },
          {
            title: '',
            dataIndex: 'cpap_id',
            width: '15%',
            align: 'center',
            render(text: string, row: any, _index) {
              return {
                props: {
                  style: { textAlign: 'center', backgroundColor: '#ff8a00', color: 'white', cursor: 'pointer' },
                  className: 'standardFont',
                  onClick: () => {
                    ref.current.openModal(row.i_id, row.patient_name);
                  },
                },
                children: (
                  <div>
                    <p style={{ backgroundColor: '#ff8a00', color: 'white', margin: 0 }}>直近の受診履歴</p>
                  </div>
                ),
              };
            },
          },
        ]}
        dataSource={data}
        pagination={false}
      />
      <ModalPatient ref={ref} />
    </div>
  );
};

export default TableConsultation;
